// .u_login-form

/*
  The ULoginForm module works as follows:
  1. Checks if the user is logged in to Wordpress. If it is, then it shows a form (.u_login-form__AMO-redirect) to redirect the user to AMO.
  2. If the user is not logged in to Wordpress, it checks for a cookie, if present it fills the username field and shows the login form.
  3. When the user fills the form and submits, it tries to log the user to Wordpress. If it fails it shows an error.
  4. If the user is succesfully logged in to Wordpress, it fills the field on the .u_login-form__amo-login form and displays it to the user (fields are hidden, to make it look like a redirect)
  5. The user clicks the button on the .u_login-form__amo-login and the form is submitted to AMO, where it is assumed that the creds are the same.
*/

class ULoginForm extends Uneet {
  constructor (domElement) {
    super(domElement)
    this.__setDebugLevel(0)
    this.hasError = false
    this.isLoading = true
    this.isReadyToLoginToAMO = false
    this.isReadyToRedirect = false
    this.wpAction = `${window.location.href.split('/').splice(0, 3).map((item) => (item === '') ? '//' : item).join('')}/WPCore/wp-login.php`
    this.amoAction = 'https://admin.associationsonline.com/secure/site_signin2.cfm'
    this.cookieName = 'WXAMOLog64-2'
    this.key = 'a8KF7>vP*i3=I420z>~~y!Ovl>wl6/*V:4f-C[G3(P?Q#X-@aGs|Y9se[lTt6**9'
    this.__init()
  }

  __init () {
    // init the component
    this.toggleLoading(true)
    this.toggleError(false)
    this.toogleReadyToLoginToAMO(false)
    this.toogleReadyToRedirect(false)

    // check if wordpress is already logged in
    const isLoggedInCallback = () => {
      this.toggleLoading(false)
      this.toogleReadyToRedirect(true)
    }
    const isNotLoggedInCallback = () => {
      this.toggleLoading(false)
    }
    this.__checkLoggedInWP(isLoggedInCallback, isNotLoggedInCallback)

    // bind the login button for the base form (WP login)
    this._e.querySelector('button.base-login-btn').onClick((ev) => {
      this.toggleLoading(true)
      this.__submitWPLogin()
    })

    // check if the cookie is already present to load the username
    const creds = this.__checkCookie()
    if (creds) {
      this.__loadUsername(creds.log)
    }
  }

  __loadUsername (username) {
    this._e.querySelector('input#wp-username').value = username
  }

  __checkLoggedInWP (isLoggedInCallback, isNotLoggedInCallback) {
    const checkURL = `${window.location.protocol}//${window.location.hostname}/WPCore/wp-admin/profile.php`
    const onIsLoggedIn = (req) => {
      this.__log('User IS logged in to Wordpress', req)
      isLoggedInCallback()
    }
    const onIsNotLoggedIn = (req) => {
      this.__log('User is NOT logged in to Wordpress', req)
      isNotLoggedInCallback()
    }
    const onError = (req) => {
      throw 'Error checking Wordpress Login'
      this.__warn(req)
    }
    const request = new XMLHttpRequest()
    request.open('GET', checkURL, true)
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        if (!request.responseText.includes('loginform')) {
          onIsLoggedIn(request)
        } else {
          onIsNotLoggedIn(request)
        }
      } else {
        onError(request)
      }
    }
    request.onError = () => {
      onError(request)
    }
    request.send()
  }

  __submitWPLogin () {
    // callback when user logged in succesfully
    const onAuthSuccess = (req, creds) => {
      this.__log('Login Succesful!', req)
      this.toggleLoading(false)
      this.toggleError(false)
      this.__prepareForRedirection(creds)
      this.toogleReadyToLoginToAMO(true)
    }
    // callback when user creds are incorrect
    const onAuthError = (req) => {
      this.__warn('Login unsuccesful', req)
      this.toggleLoading(false)
      this.toggleError(true)
    }
    // callback when there's any other type of error
    const onError = (req) => {
      throw 'Error in login'
      this.__warn(req)
      this.toggleError(false)
      this.toggleLoading(false)
    }

    const log = this._e.querySelector('input#wp-username').value
    const pwd = this._e.querySelector('input#wp-password').value
    const data = `log=${log}&pwd=${pwd}`
    const request = new XMLHttpRequest()
    request.open('POST', this.wpAction, true)
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
    request.withCredentials = true
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        if (!request.responseText.includes('login_error')) {
          onAuthSuccess(request, {log, pwd})
        } else {
          onAuthError(request)
        }
      } else {
        onError(request)
      }
    }
    request.onError = () => {
      onError(request)
    }
    request.send(data)
  }

  __checkCookie () {
    const cookie = this.__retrieveCookie()
    if (cookie) {
      return JSON.parse(cookie)
    } else {
      return false
    }
  }

  __prepareForRedirection (creds) {
    // store creds in a cookie
    this.__storeCookie({log: creds.log})
    // copy the creds to the AMO fields
    this._e.querySelector('input#username').value = creds.log
    this._e.querySelector('input#password').value = creds.pwd
  }

  toggleError (force = null) {
    this.hasError = (force !== null) ? force : !this.hasError
    this._e.toggleClass('hasError', this.hasError)
  }

  toggleLoading (force = null) {
    this.isLoading = (force !== null) ? force : !this.isLoading
    this._e.toggleClass('isLoading', this.isLoading)
  }

  toogleReadyToLoginToAMO (force = null) {
    this.isReadyToLoginToAMO = (force !== null) ? force : !this.isReadyToLoginToAMO
    this._e.toggleClass('isReadyToLoginToAMO', this.isReadyToLoginToAMO)
  }
  toogleReadyToRedirect (force = null) {
    this.isReadyToRedirect = (force !== null) ? force : !this.isReadyToRedirect
    this._e.toggleClass('isReadyToRedirect', this.isReadyToRedirect)
  }

  __storeCookie (obj) {
    // http://clubmate.fi/setting-and-reading-cookies-with-javascript/
    ((name, value, days) => {
      let expires
      if (days) {
        let date = new Date()
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
        expires = '; expires=' + date.toGMTString()
      }
      else {
        expires = ''
      }
      document.cookie = name + '=' + value + expires + '; path=/'
    })(this.cookieName, window.btoa(JSON.stringify(obj)), 10000)
  }

  __retrieveCookie () {
    const cookie = ((name) => {
      const nameEQ = name + '='
      const ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length)
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length)
        }
      }
      return null
    })(this.cookieName)
    if (cookie) {
      return window.atob(cookie)
    } else {
      return null
    }
  }
}

window.addEventListener('load', function () {
  const lfe = document.querySelector('div.u_login-form')
  if (lfe) {
    const lf = new ULoginForm(lfe)
    lf.__noop()
  }
})
